export const LabelGuest = () => {
  return <label className="nj-label-free nj-label-guest">Guest</label>;
};
